<template>
  <div class="scholarship-page">
    <div class="detail-content">
      <div class="page-title" />
      <div class="single-post 3">
        <div class="post-content">
          <article>
            <div class="background">
              <div class="container">
                <div class="hero-text col-8">
                  <h1>Scholarship</h1>
                  <p class="body-2">
                    The scholarship is now closed. A huge thanks to everyone for
                    participating!<br><br>
                    Amazon suggests what you should buy; Netflix suggests
                    what you should watch; Google suggests what you should search; Facebook
                    suggests who you should connect with. Recommendation algorithms are
                    everywhere, and they are based on your online behavior. These algorithms
                    are advancing at head-spinning speeds as more and more data is being
                    collected. They save us time and make sure we see what interests us, but
                    are they closing our minds to other experiences? Let’s discuss in essay
                    format. Welcome to 365 Data Science 2019 scholarship competition!
                  </p>
                  <a class="btn-primary" @click="scrollToWinners">Read winners’ essays</a>
                </div>
              </div>
            </div>
            <div
              class="winners-scholarship-section container"
              :class="{ container: $store.state.layout === 'mobile' }"
            >
              <h2>Winners 2019</h2>
              <div class="wrapper">
                <div class="timeline-wrapper">
                  <div class="timeline-block step-1 timeline-border col-12">
                    <div class="col-6 sm-6 left">
                      <div class="col-8 sm-9 sm-offset-1 offset-2 col">
                        <p class="h3">
                          01
                        </p>
                        <p class="h5">
                          Eleni Nisioti
                        </p>
                        <div class="info">
                          <p class="body-1">
                            Country of Residence: <span>United Kingdom</span>
                          </p>
                          <p class="body-1">
                            University: <span>University of Essex</span>
                          </p>
                          <p class="body-1">
                            Area of Study: <span>Artificial Intelligence, Ph.D.</span>
                          </p>
                        </div>
                        <ButtonArrow
                          text="Read the essay"
                          type="a"
                          href="https://365datascience.com/trending/eleni-nisioti-scholarship-winner/"
                        />
                      </div>
                      <div class="track-dot dot-1" />
                    </div>
                  </div>
                  <div class="timeline-block step-2 timeline-border  col-12">
                    <div class="col-6 sm-6 right">
                      <div class="col-8 sm-9 sm-offset-1 offset-2 col">
                        <p class="h3">
                          02
                        </p>
                        <p class="h5">
                          Andrea Uličná
                        </p>
                        <div class="info">
                          <p class="body-1">
                            Country of Residence: <span>Slovakia</span>
                          </p>
                          <p class="body-1">
                            University: <span>TBD (still at high school)</span>
                          </p>
                          <p class="body-1">
                            Area of Study: <span>TBD (Information Management)</span>
                          </p>
                        </div>
                        <ButtonArrow
                          text="Read the essay"
                          type="a"
                          href="https://365datascience.com/trending/andrea-scholarship-runner-up/"
                        />
                      </div>
                      <div class="track-dot dot-2" />
                    </div>
                  </div>
                  <div class="timeline-block step-3 timeline-border  col-12">
                    <div class="col-6 sm-6 left">
                      <div class="col-8 sm-9 sm-offset-1 offset-2 col">
                        <p class="h3">
                          03
                        </p>
                        <p class="h5">
                          John O’Neil
                        </p>
                        <div class="info">
                          <p class="body-1">
                            Country of Residence: <span>United States of America</span>
                          </p>
                          <p class="body-1">
                            University: <span>University of Illinois at Chicago</span>
                          </p>
                          <p class="body-1">
                            Area of Study: <span>Environmental and Urban Geography</span>
                          </p>
                        </div>
                        <ButtonArrow
                          text="Read the essay"
                          type="a"
                          href="https://365datascience.com/trending/john-oneil-scholarship-runner-up/"
                        />
                      </div>
                      <div class="track-dot dot-3" />
                    </div>
                  </div>
                  <div class="track-line">
                    <div class="track-line-filler" />
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import ButtonArrow from '@itbpbg/lms-components/src/components/ButtonArrow';

export default {
  components: { ButtonArrow },
  mixins: [global],
  async asyncData({ $axios, route, $config }) {
    const page = await $axios.$get(`/pages${route.fullPath}`);
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return {
      page,
      metaTitle: `${page.metaTitle}${
        +route.query.page > 1 ? ` - Page ${route.query.page}` : ''
      }`,
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [{ rel: 'canonical', href: this.canonicalURL() }],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
  mounted() {
    this.scrollAnimation();
    window.addEventListener('scroll', this.scrollAnimation);
    this.$once('hook:beforeDestroy', () => window.removeEventListener('scroll', this.scrollAnimation));
  },
  methods: {
    scrollAnimation() {
      const dots = this.$el.querySelectorAll('.track-dot');
      const line = this.$el.querySelector('.track-line');
      const lineFiller = this.$el.querySelector('.track-line .track-line-filler');
      let lineHeight = (line.getBoundingClientRect().top - window.innerHeight / 2) * -1;
      const scrolledToBottom = window.innerHeight
          + (document.documentElement.scrollTop || document.body.scrollTop)
        >= document.body.scrollHeight;

      if (lineHeight < 0) {
        lineHeight = 0;
      } else if (scrolledToBottom) {
        lineHeight = line.getBoundingClientRect().height;
      }

      dots.forEach((dot, i) => {
        setTimeout(() => {
          if (
            (lineHeight > dot.offsetParent.offsetTop && i === 0)
            || (lineHeight >= dot.offsetParent.offsetTop && i > 0)
          ) {
            dot.classList.add('filled');
          } else {
            dot.classList.remove('filled');
          }
        }, 300);
      });

      setTimeout(() => {
        lineFiller.style.height = `${lineHeight}px`;
      }, 200);
    },
    scrollToWinners() {
      document.querySelector('.winners-scholarship-section').scrollIntoView({
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.scholarship-page {
  background: var(--main-dark);
}

.background {
  background-image: url("../assets/images/background-scholarship-page.jpg") !important;
  image-rendering: -webkit-optimize-contrast;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  box-sizing: border-box;
  height: 900px;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  flex-direction: column;

  .hero-text {
    margin: auto;

    h1 {
      color: var(--main-light);
      margin-bottom: var(--spacing-16);
    }

    .body-2 {
      color: var(--main-light-shade-4);
      margin: 0 0 var(--spacing-48) 0;
    }

    .btn-primary {
      width: 300px;
      height: 58px;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 50px;
    background:
      linear-gradient(
        0deg,
        var(--main-dark) 0,
        var(--main-dark) 1%,
        rgba(0, 12, 31, 0.1) 81%,
        rgba(0, 12, 31, 0) 100%
      );
  }
}

.winners-scholarship-section {
  padding-top: var(--spacing-120);
  padding-bottom: var(--spacing-120);

  h2 {
    text-align: center;
    text-transform: capitalize;
    color: var(--main-light);
    margin: 0;
  }

  .wrapper {
    .timeline-wrapper {
      position: relative;
      margin-top: var(--spacing-120);

      .timeline-block {
        display: block;
        overflow: hidden;
        position: relative;

        &.step-2 {
          margin-top: -60px;
        }

        &.step-3 {
          margin-top: -90px;
        }

        .left {
          float: left;
        }

        .right {
          float: right;
        }

        .h3 {
          color: var(--accent);
          margin-bottom: var(--spacing-24);
        }

        .h5 {
          color: var(--main-light);
          margin-bottom: var(--spacing-24);
        }

        .info {
          margin-bottom: var(--spacing-24);

          p {
            margin: 0;
            color: var(--main-light-shade-3);

            span {
              color: var(--main-dark-shade-4);
            }
          }
        }

        .track-dot {
          position: absolute;
          right: 50%;
          margin-right: -8px;
          top: 0;
          z-index: 1;
          width: 14px;
          height: 14px;
          background: var(--main-dark-shade-2);
          border-radius: 50px;

          &.filled {
            background: var(--accent-shade-1);
            margin-right: -10px;
            width: 20px;
            height: 20px;
          }
        }

        .btn-arrow {
          cursor: pointer;
        }

        &.right {
          position: absolute;
          bottom: 200px;
          left: 50%;
          z-index: 1;
          margin-left: 155px;
          // width: 47%;

          .track-dot {
            right: calc(100% + 155px);
          }
        }

        &.left {
          margin-top: var(--spacing-120);
        }
      }

      .track-line {
        background: var(--main-dark-shade-2);
        position: absolute;
        height: 56%;
        top: 0%;
        left: 50%;
        width: 2px;
        z-index: 0;

        .track-line-filler {
          background-color: var(--accent);
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 0;
          max-height: 100%;
          transition: all 500ms ease-out;
        }

        + * {
          z-index: 1;
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .winners-scholarship-section {
    .wrapper {
      .timeline-wrapper .track-line {
        height: 59%;
      }
    }
  }
}

@include bp($bp-mobile) {
  .background {
    justify-content: flex-start;
    padding-top: var(--spacing-120);
    height: 820px;

    h1 {
      text-align: left;
      width: 100%;
      font-size: 32px;
    }

    .body-2 {
      text-align: left;
    }

    .btn-primary {
      width: 100%;
    }
  }

  .winners-scholarship-section {
    padding-top: var(--spacing-80);

    h2 {
      font-size: 32px;
      text-align: left;
    }

    .wrapper {
      padding: 0;

      .timeline-wrapper {
        margin-top: var(--spacing-80);

        .timeline-block {
          margin-bottom: 65px;

          &.step-2 {
            margin-top: 0;
          }

          &.step-3 {
            margin-top: 0;
            margin-bottom: 0;
          }

          .track-dot {
            left: 4px;
            top: 7px;

            &.filled {
              left: 1px;
              top: 5px;
            }
          }

          .right {
            float: left;
          }
        }

        .track-line {
          left: 10px;
          height: 70%;
          top: 7px;
        }
      }
    }
  }
}

@include bp($bp-tablet) {
  .background {
    .hero-text {
      h1 {
        text-align: center;
        width: 100%;
      }

      .body-2 {
        text-align: center;
      }
    }
  }
}
</style>
